import React from 'react';
import { IconProps } from '.';

const SvgRefresh = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M3.25 12a8.75 8.75 0 0 1 15.548-5.51l.196.26H16v1.5h5.75V2.5h-1.5v3.424l-.27-.358-.008-.01A10.232 10.232 0 0 0 12 1.75C6.34 1.75 1.75 6.34 1.75 12S6.34 22.25 12 22.25c5.276 0 9.62-3.986 10.188-9.112.04-.374.062-.754.062-1.138h-1.5a8.751 8.751 0 0 1-17.5 0Z'
      />
    </svg>
  );
};

export default SvgRefresh;
